<script lang="ts">
  import _ from "lodash"
  import Statement from "./PlanReview/Statement.svelte"
  import Swot from "./PlanReview/Swot.svelte"
  import {
    strengthIcon,
    weaknessIcon,
    opportunityIcon,
    threatIcon
  } from "$app/utils"
  import GoalsBoxLt from "$app/Pages/Plans/OnePageView/GoalsBoxLt.svelte"
  import GoalsBoxAnnual from "$app/Pages/Plans/OnePageView/GoalsBoxAnnual.svelte"
  import GoalsBoxDept from "$app/Pages/Plans/OnePageView/GoalsBoxDept.svelte"
  import { appStore } from "$app/store.svelte"

  let { dates, goal_data, headings } = $props()

  const plan = appStore.plan
  const departments = appStore.departments

  const longTermGoals = appStore.goals
    .filter((g) => g.type === "LongTermGoal")
    .sort((a, b) => a.parent_position - b.parent_position)

  const annualGoals = appStore.goals
    .filter((g) => g.type === "AnnualGoal")
    .sort((a, b) => a.assignee_position - b.assignee_position)

  export function valid(): boolean {
    return true
  }

  let brand_purpose = $derived(
    appStore.statements
      .filter((st) => st.section_type === "BrandPurpose")
      .sort((a, b) => a.position - b.position)[0] || ({} as StatementType)
  )

  let values = $derived(
    appStore.statements
      .filter((st) => st.section_type === "CoreValue")
      .sort((a, b) => a.position - b.position)
      .slice(0, 5)
  )

  let blue_sky_vision = $derived(
    appStore.statements
      .filter((st) => st.section_type === "BlueSkyVision")
      .sort((a, b) => a.position - b.position)[0] || ({} as StatementType)
  )

  let strengths = $derived(
    appStore.statements
      .filter((st) => st.section_type === "Strength")
      .sort((a, b) => a.position - b.position)
  )

  let weaknesses = $derived(
    appStore.statements
      .filter((st) => st.section_type === "Weakness")
      .sort((a, b) => a.position - b.position)
  )

  let opportunities = $derived(
    appStore.statements
      .filter((st) => st.section_type === "Opportunity")
      .sort((a, b) => a.position - b.position)
  )

  let threats = $derived(
    appStore.statements
      .filter((st) => st.section_type === "Threat")
      .sort((a, b) => a.position - b.position)
  )

  const options = { fiscal_year: dates.year }
</script>

<div class="w-full grid grid-cols-12 gap-4">
  <div class="col-span-12 md:col-span-3">
    <Statement
      statement={brand_purpose}
      editable={false}
      title="Brand Purpose"
      section="BrandPurpose"
    />
  </div>

  <div class="col-span-12 md:col-span-9 bg-white shadow relative" id="values">
    <div class="col-span-4 px-4 py-5 sm:px-6">
      <h2 class="leading-6 font-bold text-black text-center">Values</h2>
    </div>
    <!--Start of Values-->
    <div class="flex justify-around" data-name="values">
      {#each values as val (val.id)}
        <Statement
          statement={val}
          editable={false}
          height="h-56 value"
          section="CoreValue"
        />
      {/each}
    </div>
    <!--End of Values-->
  </div>
</div>

<div class="w-full grid grid-cols-12 gap-4 mt-4">
  <div class="col-span-12 md:col-span-3" id="blue-sky-vision">
    <Statement
      statement={blue_sky_vision}
      editable={false}
      title="Blue Sky Vision"
      section="BlueSkyVision"
    />
  </div>
  <div class="col-span-12 md:col-span-9">
    <div class="w-full grid grid-cols-2 md:grid-cols-4 gap-4">
      <div id="swot-strengths">
        <Swot
          statements={strengths}
          title="Strengths"
          sectionType="Strength"
          icon={strengthIcon}
          editable={false}
        />
      </div>
      <div id="swot-weaknesses">
        <Swot
          statements={weaknesses}
          title="Weaknesses"
          sectionType="Weakness"
          icon={weaknessIcon}
          editable={false}
        />
      </div>
      <div id="swot-opportunities">
        <Swot
          statements={opportunities}
          title="Opportunities"
          sectionType="Opportunity"
          icon={opportunityIcon}
          editable={false}
        />
      </div>
      <div id="swot-threats">
        <Swot
          statements={threats}
          title="Threats"
          sectionType="Threat"
          icon={threatIcon}
          editable={false}
        />
      </div>
    </div>
  </div>
</div>

<div class="w-full grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4" id="goal-boxes">
  <GoalsBoxLt
    {headings}
    goals={longTermGoals}
    rootGoalId={goal_data.root_goal_id}
  />

  <GoalsBoxAnnual
    {headings}
    {options}
    goals={annualGoals}
    hideCompleted={false}
  />

  {#each departments as department (department.id)}
    <GoalsBoxDept
      {department}
      hideCompleted={false}
      title="{department.name} Goals - {dates.next_quarter}"
      showAddButton={false}
      goals={appStore.goals
        .filter(
          (g) => g.assignee_id === department.id && g.type === "QuarterlyGoal"
        )
        .sort((a, b) => a.assignee_position - b.assignee_position)}
    />
  {/each}
</div>
